/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_Common_Samplecta1Inputs */

const ja_playdata_common_samplecta1 = /** @type {(inputs: Playdata_Common_Samplecta1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サンプルレポートを見る`)
};

const en_playdata_common_samplecta1 = /** @type {(inputs: Playdata_Common_Samplecta1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`See Sample Report`)
};

/**
* | output |
* | --- |
* | "See Sample Report" |
*
* @param {Playdata_Common_Samplecta1Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const playdata_common_samplecta1 = /** @type {((inputs?: Playdata_Common_Samplecta1Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_Common_Samplecta1Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_common_samplecta1(inputs)
	return en_playdata_common_samplecta1(inputs)
});
export { playdata_common_samplecta1 as "playdata_common_sampleCta" }